exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body[data-v-4ce3004e]{padding:0 5rem 5rem}@media (max-width:668px){.card-body[data-v-4ce3004e]{padding:2rem}}.card-body .content[data-v-4ce3004e]{display:flex;flex-direction:column;align-items:center;justify-content:center}.card-body .content img[data-v-4ce3004e]{margin-bottom:1rem;width:200px}.card-body .content p[data-v-4ce3004e]{margin-bottom:1rem;font-size:1rem}", ""]);

// exports
